// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--3xcWY";
export var heroWrapper = "styles-module--heroWrapper--pKygn";
export var text = "styles-module--text--gI1hX";